"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var oneAndOtherShape = (0, _propTypes.shape)({
  one: _propTypes.string.isRequired,
  other: _propTypes.string.isRequired
});
var relativeTimeLocaleShape = (0, _propTypes.shape)({
  lessThanXSeconds: oneAndOtherShape.isRequired,
  xSeconds: oneAndOtherShape.isRequired,
  halfAMinute: _propTypes.string.isRequired,
  lessThanXMinutes: oneAndOtherShape.isRequired,
  xMinutes: oneAndOtherShape.isRequired,
  aboutXHours: oneAndOtherShape.isRequired,
  xDays: oneAndOtherShape.isRequired,
  aboutXMonths: oneAndOtherShape.isRequired,
  aboutXYears: oneAndOtherShape.isRequired,
  overXYears: oneAndOtherShape.isRequired,
  almostXYears: oneAndOtherShape.isRequired,
  ago: _propTypes.string.isRequired,
  in: _propTypes.string.isRequired
});
var _default = relativeTimeLocaleShape;
exports.default = _default;